import React, {useState} from "react";
import {WdiModalAppProps} from "@/components/WdiControls";
import {Form, message, Upload} from "antd";
import {WdiModal} from "@/components/WdiControls/WdiModalForm";
import {FileUploadUtility, WdiFileUpload} from "@/components/WdiControls/WdiFileUpload";
import {Invoices} from "@/services/sales/financial/invoices";
import {ResponseStatus} from "@/utils/request";

export const InvoiceIdentifyApp: React.FC<WdiModalAppProps> = (props) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  return (
    <>
      <WdiModal
        title={props.title}
        visible={props.visible}
        onCancel={() => {
          if (!loading) {
            props.onClose?.()
          }
        }}
        okText={'识别'}
        cancelButtonProps={{
          hidden: true
        }}
        okButtonProps={{
          loading: loading
        }}
        onOk={() => {
          form.validateFields().then(() => {
            setLoading(true);
            const values = form.getFieldsValue();
            const {fileInfo} = values;
            if (FileUploadUtility.isUploading(fileInfo)) {
              message.error('附件正在上传中!');
              return;
            }
            if (FileUploadUtility.isError(fileInfo)) {
              message.error('附件存在错误文件!');
              return;
            }
            const info = FileUploadUtility.serialize(fileInfo);
            Invoices.identify({
              fileName: info.names,
              filePath: info.urls
            }).then(response => {
              if (response.code != ResponseStatus.SUCCESS) {
                message.error(response.message);
              } else {
                props.onSave?.(response);
              }
              setLoading(false);
            });
          })
        }}
      >
        <Form form={form}>
          <Form.Item
            rules={[{required: true, message: '图片不能为空!'}]}
            name='fileInfo'
            label='请选择要识别的图片'
            valuePropName='fileList'
            getValueFromEvent={(e: any) => {
              return e.fileList || [];
            }}
          >
            <WdiFileUpload
              beforeUpload={(file) => {
                const overSize = file.size > 50 * 1024 * 1024;
                if (overSize) {
                  message.error('文件过大，不能识别');
                }
                return !overSize || Upload.LIST_IGNORE;
              }}
              leftTopInfo=''
              maxCount={1}
            />
          </Form.Item>
        </Form>
      </WdiModal>
    </>
  );
}
